import React from 'react';
import { Space, Text, Button, Image } from '@cashfree-intl/coherent';
import CheckoutCardSvg from 'images/CheckoutJourney/CheckoutCard.svg';
import { basename } from 'store';
import { CheckoutCardProps } from 'containers/CheckoutJourney/types';
import { CardSpace } from 'containers/CheckoutJourney/styled';

const CheckoutCard = ({
  imageSrc = CheckoutCardSvg,
  imageAlt = 'Checkout Card',
  title = 'Start Collecting Payments Now!',
  description = 'Pick the best payment solution for your business. Go live in less than a day with our assisted guide.',
  buttonText = 'Get started now',
  buttonLink = `${basename}checkout-journey`,
}: CheckoutCardProps) => {
  const onGetStarted = () => {
    window.location.assign(buttonLink);
  };

  return (
    <CardSpace direction="column" gap={3} fullWidth>
      <Space direction="column" gap={3} fullWidth>
        <Image src={imageSrc} alt={imageAlt} />
        <Text variant="h16" strong>
          {title}
        </Text>
        <Text variant="b14" color="bodyLight">
          {description}
        </Text>
        <Button primary onClick={onGetStarted}>
          <Text variant="b14" color="white" strong>
            {buttonText}
          </Text>
        </Button>
      </Space>
    </CardSpace>
  );
};

export default CheckoutCard;
